/* eslint-disable camelcase */
/*
 * Datazoom, Inc ("COMPANY") CONFIDENTIAL
 * Copyright (c) 2017-2018 [Datazoom, Inc.], All Rights Reserved.
 *
 * This file is subject to the terms and conditions defined in
 * file 'LICENSE.txt', which is part of this source code package.
 */

// Action Creator
export const types = {
  COLLECTOR_MANAGEMENT_LIST: "[CollectorMgmt] Collector Management List",
  COLLECTOR_MANAGEMENT_LIST_SUCCESS:
    "[CollectorMgmt] Collector Management List Success",
  COLLECTOR_MANAGEMENT_LIST_FAILED:
    "[CollectorMgmt] Collector Management List Failed ",
  CLEAR_COLLECTOR_MANAGEMENT_LIST:
    "[CollectorMgmt] Clear Collector Management List",
  FETCH_A_COLLECTOR_LOGS: "[CollectorMgmt] Fetch a Collector Logs",
  FETCH_A_COLLECTOR_LOGS_SUCCESS:
    "[CollectorMgmt] Fetch a Collector Logs Success",
  FETCH_A_COLLECTOR_LOGS_FAILED:
    "[CollectorMgmt] Fetch a Collector Logs failed",
  FETCH_A_COLLECTOR_MANAGEMENT:
    "[CollectorMgmt] Fetch a Collector Manage Detail",
  FETCH_A_COLLECTOR_MANAGEMENT_SUCCESS:
    "[CollectorMgmt] Fetch a Collector Management Success",
  FETCH_A_COLLECTOR_MANAGEMENT_FAILED:
    "[CollectorMgmt] Fetch a Collector Management Failed",
  CREATE_COLLECTOR_MANAGEMENT_JIRA:
    "[CollectorMgmt] Create Collector Management jira",
  CREATE_COLLECTOR_MANAGEMENT_JIRA_SUCCESS:
    "[CollectorMgmt] Create Collector Management jira success",
  CREATE_COLLECTOR_MANAGEMENT_JIRA_FAILED:
    "[CollectorMgmt] Create Collector Management jira failed",
  CLEAR_COLLECTOR_MANAGEMENT_DETAILS:
    "[CollectorMgmt] Clear Collector Management Details",
  CREATE_COLLECTOR: "[CollectorMgmt] Create collector",
  CREATE_COLLECTOR_SUCCESS: "[CollectorMgmt] Create Collector Success",
  CREATE_COLLECTOR_FAILED: "[CollectorMgmt] Create Collector Failed",
  CLEAR_CREATE_COLLECTOR_FAILED_RESPONSE:
    "[CollectorMgmt] Clear create collector failed response",
  UPDATE_COLLECTOR_MANAGEMENT: "[CollectorMgmt] Update Collector Management",
  UPDATE_COLLECTOR_MANAGEMENT_SUCCESS:
    "[CollectorMgmt] Update Collector Management Success",
  UPDATE_COLLECTOR_MANAGEMENT_FAILED:
    "[CollectorMgmt] Update Collector Management Failed",
  CREATE_AD_FRAMEWORK: "[CollectorMgmt] Create Ad Framework",
  CREATE_AD_FRAMEWORK_SUCCESS: "[CollectorMgmt] Create Ad Framework Success",
  CREATE_AD_FRAMEWORK_FAILED: "[CollectorMgmt] Create Ad Framework Failed",
  FETCH_SUPPORTED_DATA_POINTS:
    "[CollectorMgmt] Fetch Collector Management Supported Data Points",
  FETCH_SUPPORTED_DATA_POINTS_SUCCESS:
    "[CollectorMgmt] Fetch Collector Management Supported Data Points Success",
  FETCH_SUPPORTED_DATA_POINTS_FAILED:
    "[CollectorMgmt] Fetch Collector Management Supported Data Points Failed",
  FETCH_MORE_SUPPORTED_DATA_POINTS:
    "[CollectorMgmt] Fetch More Collector Management Supported Data Points",
  FETCH__MORE_SUPPORTED_DATA_POINTS_SUCCESS:
    "[CollectorMgmt] Fetch  More  Collector Management Supported Data Points Success",
  FETCH__MORE_SUPPORTED_DATA_POINTS_FAILED:
    "[CollectorMgmt] Fetch  More Collector Management Supported Data Points Failed",
  CLEAR_SUPPORTED_DATA_POINTS:
    "[CollectorMgmt] Clear Collector Management Supported Data Points",
  CREATE_MEDIAPLAYER: "[CollectorMgmt] Create MediaPlayer",
  CREATE_MEDIAPLAYER_SUCCESS: "[CollectorMgmt] Create MediaPlayer Success",
  CREATE_MEDIAPLAYER_FAILED: "[CollectorMgmt] Create MediaPlayer Failed",
  FETCH_SUPPORTED_DATA_POINTS_OVERLAY:
    "[CollectorMgmt] Fetch Collector Management Supported Data Points Overlay",
  FETCH_SUPPORTED_DATA_POINTS_SUCCESS_OVERLAY:
    "[CollectorMgmt] Fetch Collector Management Supported Data Points Success Overlay",
  FETCH_SUPPORTED_DATA_POINTS_FAILED_OVERLAY:
    "[CollectorMgmt] Fetch Collector Management Supported Data Points Failed Overlay",
  FETCH_MORE_SUPPORTED_DATA_POINTS_OVERLAY:
    "[CollectorMgmt] Fetch More Collector Management Supported Data Points Overlay",
  FETCH__MORE_SUPPORTED_DATA_POINTS_SUCCESS_OVERLAY:
    "[CollectorMgmt] Fetch  More  Collector Management Supported Data Points Success Overlay",
  FETCH__MORE_SUPPORTED_DATA_POINTS_FAILED_OVERLAY:
    "[CollectorMgmt] Fetch  More Collector Management Supported Data Points Failed Overlay",
  CLEAR_SUPPORTED_DATA_POINTS_OVERLAY:
    "[CollectorMgmt] Clear Collector Management Supported Data Points Overlay",
  AUTHORED_UNAUTHORED_DATAPOINT:
    "[CollectorMgmt] Author or Unauthor a Datapoint",
  AUTHORED_UNAUTHORED_DATAPOINT_SUCCESS:
    "[CollectorMgmt] Author or Unauthor a Datapoint Success",
  AUTHORED_UNAUTHORED_DATAPOINT_FAILED:
    "[CollectorMgmt] Author or Unauthor a Datapoint Failed",
  CLEAR_AUTHORED_UNAUTHORED_DATAPOINT_MESSAGES:
    "[CollectorMgmt] Clear Author or Unauthor a Datapoint Messages",
};

export const CollectorMgmtList = (query) => ({
  type: types.COLLECTOR_MANAGEMENT_LIST,
  payload: query,
});
export const CollectorMgmtListSuccess = (list) => ({
  type: types.COLLECTOR_MANAGEMENT_LIST_SUCCESS,
  payload: list,
});
export const CollectorMgmtListListFailed = (error) => ({
  type: types.COLLECTOR_MANAGEMENT_LIST_FAILED,
  payload: error,
});
export const ClearCollectorMgmtList = () => ({
  type: types.CLEAR_COLLECTOR_MANAGEMENT_LIST,
});
export const FetchACollectorMgmt = (collector) => ({
  type: types.FETCH_A_COLLECTOR_MANAGEMENT,
  payload: collector,
});
export const FetchACollectorMgmtSuccess = (data, additionalInfo) => ({
  type: types.FETCH_A_COLLECTOR_MANAGEMENT_SUCCESS,
  payload: { data, additionalInfo },
});
export const FetchACollectorMgmtFailed = (error) => ({
  type: types.FETCH_A_COLLECTOR_MANAGEMENT_FAILED,
  payload: error,
});
export const CreateCollectorMgmtJira = (data) => ({
  type: types.CREATE_COLLECTOR_MANAGEMENT_JIRA,
  payload: data,
});
export const CreateCollectorMgmtJiraSuccess = (response) => ({
  type: types.CREATE_COLLECTOR_MANAGEMENT_JIRA_SUCCESS,
  payload: response,
});
export const CreateCollectorMgmtJiraFailed = (error) => ({
  type: types.CREATE_COLLECTOR_MANAGEMENT_JIRA_FAILED,
  payload: error,
});
export const ClearCollectorMgmtDetails = () => ({
  type: types.CLEAR_COLLECTOR_MANAGEMENT_DETAILS,
});
export const CreateCollector = (collector) => ({
  type: types.CREATE_COLLECTOR,
  payload: collector,
});
export const CreateCollectorSuccess = (response) => ({
  type: types.CREATE_COLLECTOR_SUCCESS,
  payload: response,
});
export const CreateCollectorFailed = (error) => ({
  type: types.CREATE_COLLECTOR_FAILED,
  payload: error,
});
export const ClearCreateCollectorFailedResponse = () => ({
  type: types.CLEAR_CREATE_COLLECTOR_FAILED_RESPONSE,
});
export const UpdateCollectorMgmt = (collector, type) => ({
  type: types.UPDATE_COLLECTOR_MANAGEMENT,
  payload: { collector, type },
});
export const UpdateCollectorMgmtSuccess = (response) => ({
  type: types.UPDATE_COLLECTOR_MANAGEMENT_SUCCESS,
  payload: response,
});
export const UpdateCollectorMgmtFailed = (error) => ({
  type: types.UPDATE_COLLECTOR_MANAGEMENT_FAILED,
  payload: error,
});

export const FetchACollectorLogs = (collector) => ({
  type: types.FETCH_A_COLLECTOR_LOGS,
  payload: collector,
});
export const FetchACollectorLogsSuccess = (logs) => ({
  type: types.FETCH_A_COLLECTOR_LOGS_SUCCESS,
  payload: logs,
});
export const FetchACollectorLogsFailed = (error) => ({
  type: types.FETCH_A_COLLECTOR_LOGS_FAILED,
  payload: error,
});
export const CreateAdFramework = (adFramework) => ({
  type: types.CREATE_AD_FRAMEWORK,
  payload: adFramework,
});
export const CreateAdFrameworkSuccess = (data) => ({
  type: types.CREATE_AD_FRAMEWORK_SUCCESS,
  payload: data,
});
export const CreateAdFrameworkFailed = (error) => ({
  type: types.CREATE_AD_FRAMEWORK_FAILED,
  payload: error,
});
export const FetchSupportedDataPoints = (
  playerId,
  page,
  size,
  order,
  query,
  filters,
  resourceType,
  order_by,
) => ({
  type: types.FETCH_SUPPORTED_DATA_POINTS,
  payload: {
    playerId,
    page,
    size,
    order,
    query,
    filters,
    resourceType,
    order_by,
  },
});
export const FetchSupportedDataPointsSuccess = (data) => {
  return {
    type: types.FETCH_SUPPORTED_DATA_POINTS_SUCCESS,
    payload: data,
  };
};
export const FetchSupportedDataPointsFailed = (data) => {
  return {
    type: types.FETCH_SUPPORTED_DATA_POINTS_SUCCESS,
    payload: data,
  };
};
export const FetchMoreSupportedDataPoints = (
  playerId,
  page,
  size,
  order,
  query,
  filters,
  resourceType,
  order_by,
) => ({
  type: types.FETCH_MORE_SUPPORTED_DATA_POINTS,
  payload: {
    playerId,
    page,
    size,
    order,
    query,
    filters,
    resourceType,
    order_by,
  },
});
export const FetchMoreSupportedDataPointsSuccess = (data) => {
  return {
    type: types.FETCH__MORE_SUPPORTED_DATA_POINTS_SUCCESS,
    payload: data,
  };
};
export const FetchMoreSupportedDataPointsFailed = (data) => {
  return {
    type: types.FETCH__MORE_SUPPORTED_DATA_POINTS_FAILED,
    payload: data,
  };
};
export const ClearSupportedDataPoints = () => {
  return {
    type: types.CLEAR_SUPPORTED_DATA_POINTS,
  };
};
export const CreateMediaPlayer = (mediaPlayer) => ({
  type: types.CREATE_MEDIAPLAYER,
  payload: mediaPlayer,
});
export const CreateMediaPlayerSuccess = (data) => ({
  type: types.CREATE_MEDIAPLAYER_SUCCESS,
  payload: data,
});
export const CreateMediaPlayerFailed = (error) => ({
  type: types.CREATE_MEDIAPLAYER_FAILED,
  payload: error,
});

export const FetchSupportedDataPointsOverlay = (
  playerId,
  page,
  size,
  order,
  query,
  filters,
  resourceType,
  order_by,
) => ({
  type: types.FETCH_SUPPORTED_DATA_POINTS_OVERLAY,
  payload: {
    playerId,
    page,
    size,
    order,
    query,
    filters,
    resourceType,
    order_by,
  },
});
export const FetchSupportedDataPointsSuccessOverlay = (data) => {
  return {
    type: types.FETCH_SUPPORTED_DATA_POINTS_SUCCESS_OVERLAY,
    payload: data,
  };
};
export const FetchSupportedDataPointsFailedOverlay = (data) => {
  return {
    type: types.FETCH_SUPPORTED_DATA_POINTS_SUCCESS_OVERLAY,
    payload: data,
  };
};
export const FetchMoreSupportedDataPointsOverlay = (
  playerId,
  page,
  size,
  order,
  query,
  filters,
  resourceType,
  order_by,
) => ({
  type: types.FETCH_MORE_SUPPORTED_DATA_POINTS_OVERLAY,
  payload: {
    playerId,
    page,
    size,
    order,
    query,
    filters,
    resourceType,
    order_by,
  },
});
export const FetchMoreSupportedDataPointsSuccessOverlay = (data) => {
  return {
    type: types.FETCH__MORE_SUPPORTED_DATA_POINTS_SUCCESS_OVERLAY,
    payload: data,
  };
};
export const FetchMoreSupportedDataPointsFailedOverlay = (data) => {
  return {
    type: types.FETCH__MORE_SUPPORTED_DATA_POINTS_FAILED_OVERLAY,
    payload: data,
  };
};
export const ClearSupportedDataPointsOverlay = () => {
  return {
    type: types.CLEAR_SUPPORTED_DATA_POINTS_OVERLAY,
  };
};
export const AuthorOrUnAuthorADataPoint = (data) => {
  return {
    type: types.AUTHORED_UNAUTHORED_DATAPOINT,
    payload: data,
  };
};

export const AuthorOrUnAuthorADataPointSuccess = (data) => {
  return {
    type: types.AUTHORED_UNAUTHORED_DATAPOINT_SUCCESS,
    payload: data,
  };
};

export const AuthorOrUnAuthorADataPointFailed = (data) => {
  return {
    type: types.AUTHORED_UNAUTHORED_DATAPOINT_FAILED,
    payload: data,
  };
};

export const ClearAuthorOrUnAuthorADataPointMsgs = () => {
  return {
    type: types.CLEAR_AUTHORED_UNAUTHORED_DATAPOINT_MESSAGES,
  };
};
